module.exports = __webpack_public_path__ + "img/default.875d837d.png";